<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <!-- <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.DASHBOARD'"> </span></div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.DASHBOARD'"> </span></li>
                        </ol>
                    </nav>
                </div>
            </div> -->
            <!--end breadcrumb-->

            <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3">
                <div class="col">
                    <div class="card radius-10" routerLink="/users" style="cursor: pointer;">
                        <div class="card-body">
                            <div class="d-flex align-items-center py-2">
                                <div class="widgets-icons gradient1-bg white-color border white-border me-3">
                                    <i class='bx bx-user-circle'></i>
                                </div>
                                <div>
                                    <p class="mb-0"><span [translate]="'GREATER.TOTAL'"> </span> <span [translate]="'GREATER.USERS'"> </span></p>
                                    <h2 class="title mt-1 mb-0">{{detaildata.total_user_count}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card radius-10" routerLink="/organisations" style="cursor: pointer;">
                        <div class="card-body">
                            <div class="d-flex align-items-center py-2">
                                <div class="widgets-icons gradient1-bg white-color border white-border me-3">
                                    <i class='bx bx-badge-check'></i>
                                </div>
                                <div>
                                    <p class="mb-0"><span [translate]="'GREATER.TOTAL'"> </span> <span [translate]="'GREATER.ORGANISATIONS'"> </span></p>
                                    <h2 class="title mt-1 mb-0">{{detaildata.total_organisation_count}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card radius-10" routerLink="/creators" style="cursor: pointer;">
                        <div class="card-body">
                            <div class="d-flex align-items-center py-2">
                                <div class="widgets-icons gradient1-bg white-color border white-border me-3">
                                    <i class='bx bx-briefcase'></i>
                                </div>
                                <div>
                                    <p class="mb-0"><span [translate]="'GREATER.TOTAL'"> </span> <span [translate]="'GREATER.CREATORS'"> </span></p>
                                    <h2 class="title mt-1 mb-0">{{detaildata.total_creator_count}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->
        </div>
    </div>
    <!--end page wrapper -->
    <!--start overlay-->
    <div class="overlay toggle-icon"></div>
    <app-footer></app-footer>
</div>